import React, {useMemo} from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory, {PaginationProvider,} from "react-bootstrap-table2-paginator";
import {
    headerSortingClasses,
    NoRecordsFoundMessage,
    PleaseWaitMessage,
    sortCaret
} from "../../../../../_metronic/_helpers";
import * as uiHelpers from "../../../baskets/BasketsUIHelpers";
import {Pagination} from "../../../../../_metronic/_partials/controls";
import * as columnFormatters from "../../column-formatters";
import {useProductsUIContext} from "../../ProductsUIContext";
import {domain} from "../../../../../_metronic/_helpers/GlobalConsts";

export default function PhotosTable({
                                        handlePreview
                                    }) {

    const productContext = useProductsUIContext();
    const productUIProps = useMemo(() => {
        return {
            id: productContext.id,
            product: productContext.product,
            photos: productContext.photos,
            setPhotos: productContext.setPhotos,
            error: productContext.error,
            setError: productContext.setError,
            setOpenError: productContext.setOpenError,
        };
    }, [productContext]);

    function imageFormatter(cell, row, rowIndex, formatExtraData) {
        return (
            <img className="img-thumbnail" src={domain + row.url} width={300}/>
        );
    }

    // Table columns
    const columns = [
        {
            dataField: "photo",
            text: "تصویر",
            formatter: imageFormatter
        },
        {
            dataField: "action",
            text: "عملیات",
            formatter: columnFormatters.ImageColumnFormatter,
            formatExtraData: {
                title: "Photos",
                previewClick: handlePreview,
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
        },
    ];

    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: productUIProps.photos.length,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: 15,
        page: 1,
    };

    return (
        <>
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({paginationProps, paginationTableProps}) => {
                    return (
                        <Pagination
                            isLoading={false}
                            paginationProps={paginationProps}
                        >
                            <ToolkitProvider
                                keyField="id"
                                data={productUIProps.product.images}
                                columns={columns}
                            >
                                {
                                    props => (
                                        <div>
                                            <BootstrapTable
                                                wrapperClasses="table-responsive"
                                                bordered={false}
                                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                                bootstrap4
                                                defaultSorted={uiHelpers.defaultSorted}
                                                {...paginationTableProps}
                                                {...props.baseProps}
                                            >
                                                <PleaseWaitMessage entities={productUIProps.photos}/>
                                                <NoRecordsFoundMessage entities={productUIProps.photos}/>
                                            </BootstrapTable>
                                        </div>
                                    )
                                }
                            </ToolkitProvider>
                        </Pagination>
                    );
                }}
            </PaginationProvider>
        </>
    )
}